import ProductViewModel from '../../viewmodels/productviewmodel';
import ko from 'knockout';
import modal from '../../../../smartpak/modal';

function TesProductViewModel(data) {
    ProductViewModel.call(this, data);

    this.cost = ko.computed(
        function() {
            var priceModel = this.price,
                price = convertCostToNumber(priceModel.current());

            return price.toFixed(2);
        }.bind(this)
    );

    this.isAutoShip = ko.observable(this.hasDaysSupply());

    this.daysSupplyInput = ko.observable(this.hasDaysSupply() ? this.daysSupply() : '');

    this.daysSupplyInput.subscribe(
        function(input) {
            this.isAutoShip(!!input);

            if (!this.customerIsSmartPrimeEligible && this.isInvalidPerksEligibleItem()) {
                showPerksEligibleWarningModal();
            }
        }.bind(this)
    );
}

function convertCostToNumber(str) {
    return +(/^\$/.test(str) ? str.substring(1) : str);
}

function showPerksEligibleWarningModal() {
    modal(document.querySelector('.frequency'), {
        title: "Head's Up!"
    });
}

export default TesProductViewModel;
